import type { JobSalary, MetroArea, Quantile } from "@lossdog/job-watchlists";
import { create } from "zustand";

interface WatchlistSelectionsState {
  // Selections
  selectedWatchlistGroup: { id: string; title: string } | null;
  selectedWatchlist: { id: string; title: string } | null;
  selectedMetroArea: MetroArea | null;
  selectedQuantile: Quantile | null;
  selectedJobSalary: JobSalary | null;

  // Actions
  setSelectedWatchlistGroup: (group: { id: string; title: string } | null) => void;
  setSelectedWatchlist: (watchlist: { id: string; title: string } | null) => void;
  setSelectedMetroArea: (metroArea: MetroArea | null) => void;
  setSelectedQuantile: (quantile: Quantile | null) => void;
  setSelectedJobSalary: (jobSalary: JobSalary | null) => void;
}

export const useWatchlistSelectionsStore = create<WatchlistSelectionsState>((set) => ({
  selectedWatchlistGroup: null,
  selectedWatchlist: null,
  selectedMetroArea: null,
  selectedQuantile: null,
  selectedJobSalary: null,

  setSelectedWatchlistGroup: (selectedWatchlistGroup) => set({ selectedWatchlistGroup }),
  setSelectedWatchlist: (selectedWatchlist) => set({ selectedWatchlist }),
  setSelectedMetroArea: (selectedMetroArea) => set({ selectedMetroArea }),
  setSelectedQuantile: (selectedQuantile) => set({ selectedQuantile }),
  setSelectedJobSalary: (selectedJobSalary) => set({ selectedJobSalary }),
}));
